import {legendaryRarity, magicRarity, mythicRarity, normalRarity, rareRarity, setRarity, uniqueRarity} from "./D4Enums";

export const COLOR_SUCCESS = "#365e3d";
export const COLOR_ERROR = "#660000";

export const COLOR_VARIATION_SUCCESS = "#77CA85";
export const COLOR_VARIATION_ERROR = "#EF8F8F";

export const COLOR_OCHRE = "#dca779";

export const COLOR_ORANGE = "#ff8000";
export const COLOR_YELLOW = "#e5e848";
export const COLOR_WHITE = "#ffffff";
export const COLOR_BLUE = "rgb(118, 134, 179)";
export const COLOR_GRAY = "#aaa";
export const COLOR_TEAL = "#7dd6e8";
export const COLOR_DARK_TEAL = "#047d95";
export const COLOR_VIOLET="#CDA1D8"

export const COLOR_GREAT_AFFIX = "#EBD1BA";
export const COLOR_MYTHIC = COLOR_VIOLET;
export const COLOR_UNIQUE = COLOR_OCHRE;
export const COLOR_SET = "#6aff00";
export const COLOR_LEGENDARY = COLOR_ORANGE;
export const COLOR_RARE = COLOR_YELLOW;
export const COLOR_MAGIC = COLOR_BLUE;
export const COLOR_NORMAL = COLOR_WHITE;
export const COLOR_LAIR_BOSS_KEY = "#56bef0";
export const COLOR_RUNE = "#ebb482";

//D4 Season 12 Bloodied Items
export const COLOR_BLOODIED = "#C73F3F";

export const getColorByRarity = function(rarity, defaultColor) {
    let color;
    switch (rarity) {
        case normalRarity:
            color = COLOR_NORMAL;
            break;
        case magicRarity:
            color = COLOR_MAGIC;
            break;
        case rareRarity:
            color = COLOR_RARE;
            break;
        case legendaryRarity:
            color = COLOR_LEGENDARY;
            break;
        case uniqueRarity:
            color = COLOR_UNIQUE;
            break;
        case mythicRarity:
            color = COLOR_MYTHIC;
            break;
        case setRarity:
            color = COLOR_SET;
            break;
        default:
            color = defaultColor
    }

    return color;
}